export default __webpack_public_path__ + "static/media/donate_idea.9955ff03.svg";